import { StoreSettingsState } from "./type";

export const StoreSettingsInitialState: StoreSettingsState = {
  error: null,
  loading: false,
  qualities: [],
};
